import React, { useCallback, useEffect, useState } from 'react';
import EditIcon from '../../../components/Icons/EditIcon';
import ClientButton from '../../../components/ClientButton';
import AddIcon from '../../../components/Icons/AddIcon';
import DeleteIcon from '../../../components/Icons/DeleteIcon';
import ModalWithHeading from '../../../components/ModalWithHeading';
import ModalWithHeadingSmall from '../../../components/ModalWithHeadingSmall';
import Loader from '../../../components/Loader';
import { getProfileDataApi } from '../../../redux/Reducers/ProfileReducer';
import { updateProfileApi } from '../../../redux/Reducers/MyAccountReducer';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { phone_add_plus_one } from '../../../utils/commonUtil';
import { getAllServiceAddressesApi } from '../../../redux/Reducers/ServiceAddressesReducer';

const AddressList = ({ options = [], value = [], onChange }) => {
  const checkedIds = (value || []).map((v) => String(v.service_address_id));
  const toggle = (id) => {
    const exists = checkedIds.includes(String(id));
    let next = [...(value || [])];
    if (exists) {
      next = next.filter((v) => String(v.service_address_id) !== String(id));
    } else {
      next.push({ service_address_id: String(id), operation: 'CREATE' });
    }
    onChange?.(next);
  };
  return (
    <>
      {options?.map((option) => (
        <label className='flex' key={option?.id}>
          <input
            onChange={() => toggle(option?.id)}
            checked={checkedIds.includes(String(option?.id))}
            type='checkbox'
            value={option?.id}
            className='form-checkbox mt-1.5'
          />
          <span className='go-textblacknormal-16 ml-2 pt-0.5'>{option?.full_address}</span>
        </label>
      ))}
    </>
  );
};
import ModalBasic from '../../../components/Modal';
import Button from '../../../components/Button';
import PhoneField from '../../../components/PhoneField';
export default function AddMemberModal({ modalOpen, setModalOpen, data }) {
  const dispatch = useDispatch();
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [newlyAddedMember, setNewlyAddedMember] = useState(null);
  const addMemberModalFn = useCallback((e, val) => {
    e.stopPropagation();
    setAddMemberModal(val);
  }, []);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    service_addresses: [],
  });
  const [formErrors, setFormErrors] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddressesChange = (addresses) => {
    setFormData((prev) => ({ ...prev, service_addresses: addresses }));
  };

  const validate = () => {
    const errors = {};
    if (!formData.first_name?.trim()) errors.first_name = 'First name is required';
    if (!formData.last_name?.trim()) errors.last_name = 'Last name is required';
    if (!formData.email?.trim()) errors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email is invalid';
    if (!formData.phone_number || formData.phone_number.length < 12) errors.phone_number = 'Phone number is required';
    if (
      !formData.service_addresses ||
      (Array.isArray(formData.service_addresses) && formData.service_addresses.length === 0)
    )
      errors.service_addresses = 'Please select at least one service address';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e?.preventDefault?.();
    if (!validate()) return;
    setEditLoading(true);
    const member = {
      operation: 'CREATE',
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: { phone_number: formData.phone_number },
      service_addresses: formData.service_addresses,
    };
    const payload = { members: [member] };
    updateProfileApi(payload).then((res) => {
      setEditLoading(false);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        addMemberModalFn({ stopPropagation: () => {} }, true);
        toast.success('Member added successfully!');
        setNewlyAddedMember(payload?.members[0]);
      } else {
        if (res?.message?.includes && res?.message?.includes('phone')) {
          setFormErrors((prev) => ({
            ...prev,
            phone_number: `The member's phone number you entered is not in the correct format.`,
          }));
        }
        if (res?.message?.includes && res?.message?.includes('already')) {
          setFormErrors((prev) => ({ ...prev, email: 'The mail address entered belongs to an existing account.' }));
        }
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };

  return (
    <ModalBasic
      id='add-member-modal'
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={'Add New Member'}
      width='md'
    >
      <div className=' border-b border-gray-100 p-6'>
        {editLoading ? (
          <Loader text='processing...' classes=' h-96' />
        ) : (
          <form onSubmit={onSubmit}>
            <div>
              <div className=' flex space-x-2'>
                <div className=' mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16 mb-1 block' htmlFor='label'>
                    First Name
                  </label>
                  <input
                    name='first_name'
                    className={`go-inputtext-16`}
                    value={formData.first_name}
                    onChange={handleChange}
                    type='text'
                  />
                  {formErrors.first_name && <p className='go-textnormal-14 text-red-500'>{formErrors.first_name}</p>}
                </div>
                <div className=' mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16 mb-1 block' htmlFor='label'>
                    Last Name
                  </label>
                  <input
                    name='last_name'
                    className={`go-inputtext-16`}
                    value={formData.last_name}
                    onChange={handleChange}
                    type='text'
                  />
                  {formErrors.last_name && <p className='go-textnormal-14 text-red-500'>{formErrors.last_name}</p>}
                </div>
              </div>
              <div className='relative mb-4 flex-row space-y-1.5'>
                <label className='go-label-16 mb-1 block' htmlFor='label'>
                  Email
                </label>
                <input
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  className={`go-inputtext-16 ${formErrors?.email ? 'border-red-500' : ''}`}
                  type='email'
                />
                {formErrors.email && <p className='go-textnormal-14 text-red-500'>{formErrors.email}</p>}
              </div>
              {/* phone type removed - not required for new members */}
              <div className='relative mb-4 flex-row space-y-1.5'>
                <PhoneField
                  required
                  label='Phone'
                  name='phone_number'
                  value={formData.phone_number}
                  onChange={(e, apiValue) => {
                    if (apiValue) {
                      setFormData((prev) => ({ ...prev, phone_number: apiValue }));
                    } else if (e?.target) {
                      handleChange(e);
                    }
                  }}
                  error={formErrors.phone_number}
                />
              </div>
              <div className='min- relative mb-4 flex-row space-y-1.5'>
                <label className='go-label-16  mb-1 block' htmlFor='label'>
                  Service Address
                </label>
                <AddressList
                  options={data?.addresses}
                  value={formData.service_addresses}
                  onChange={handleAddressesChange}
                />
                {formErrors.service_addresses && (
                  <p className='go-textnormal-14 mt-2 text-red-500'>{formErrors.service_addresses}</p>
                )}
              </div>
            </div>
          </form>
        )}
      </div>
      <div className='flex space-x-4 p-5'>
        <Button
          variant='secondary'
          text='Cancel'
          classes='w-full'
          onClick={() => {
            setModalOpen(false);
          }}
        />
        <Button variant='primary-dark' text='Save' classes='w-full' onClick={onSubmit} />
      </div>
      <ModalWithHeadingSmall
        modalOpen={addMemberModal}
        setModalOpen={setAddMemberModal}
        title={`${newlyAddedMember?.first_name} ${newlyAddedMember?.last_name} has been added to your Organization.`}
        classes='max-w-lg py-4'
        clickOutsiteToClose={false}
      >
        <div className='mx-8'>
          <div>
            <p className='go-label-16 py-4 text-center'>
              An email with a link to set their password has been sent to {`${newlyAddedMember?.email}`}
            </p>
          </div>
          <div className='flex justify-center py-3 '>
            <ClientButton
              variant='primary'
              text='Close'
              classes=''
              onClick={() => {
                dispatch(getProfileDataApi(false));
                setAddMemberModal(false);
                // setAdd(false);
              }}
            />
          </div>
        </div>
      </ModalWithHeadingSmall>
    </ModalBasic>
  );
}
